import { notification } from 'antd';
import { action, autorun, observable, computed } from 'mobx';
import moment from 'moment';

import {
  fetchCalendarList,
  fetchClinic,
  fetchSpecialists,
  fetchAllClinic,
  getClientList,
  getDailyBookingsByRoom,
} from './service';
import * as api from '../../../stores/api';

class Store {
  @observable loading = true;
  @observable loadingSpecialists = true;
  @observable loadingClients = true;
  @observable loadingClinics = true;
  @observable dataDailyBooking = null;
  @observable clinics = [];
  @observable sessions = [];
  @observable doctors = [];
  @observable initialView = 'dayGridMonth';
  @observable clients = [];
  @observable keywordClient = '';
  @observable numberClient = 30;
  @observable isReloadCalendar = false;
  @observable isResetStore = false;
  @observable currentDate = null;

  @observable timeZone = moment.tz.guess();
  //----------------------------------------------------------------
  @observable GoToDate = '';
  @observable dateForDailyBooking = '';
  @observable clinicId = 0;
  @observable doctorId = 0;
  @observable end = `${moment()
    .add(3, 'month')
    .format('DD/MM/YYYY')}`;
  @observable start = `${moment()
    .subtract(1, 'week')
    .format('DD/MM/YYYY')}`;
  @observable isHomeVisit = false;
  @observable onlySessions = false;
  @observable onlyTeleAssessment = false;

  //----------------------------------------------------------------
  @observable specialistKeyword = '';
  @observable specialistNumber = 30;
  //----------------------------------------------------------------
  @observable clinicId = 0;
  @observable isHomeVisit = false;
  @observable calendarViewMode = 'month';

  @observable open = false;
  @observable modalParams = {};

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @computed get doctorSelected() {
    const { doctorId } = this;
    return this.doctors.find(doctor => doctor.Id === doctorId) || null;
  }

  @computed get clinicSelected() {
    const { clinicId } = this;
    return this.clinics.find(clinic => clinic.Id === clinicId) || null;
  }

  @action setFieldsValue = data => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  };

  getTimezone = () => {
    const leadZero = num => (num < 10 ? '0' + num : num);

    const tzOffset = -1 * new Date().getTimezoneOffset();
    const hour = ~~Math.abs(tzOffset / 60);
    const minute = Math.abs(tzOffset % 60);

    return `${tzOffset < 0 ? '-' : '+'}${leadZero(hour)}:${leadZero(minute)}`;
  };

  handleSearch = () => {
    if (this.calendarViewMode !== 'dailyBookingByRooms') {
      if (this.start && this.end) {
        this.setFieldsValue({ loading: true });
        const start = this.start
          ? moment(this.start, 'DD/MM/YYYY').format('DD/MM/YYYY')
          : null;
        const end = this.end
          ? moment(this.end, 'DD/MM/YYYY').format('DD/MM/YYYY')
          : null;
        const start_ = start
          ? moment(start, 'DD/MM/YYYY')
              .startOf('day')
              .tz(this.timeZone)
              .format()
          : end
          ? moment(end, 'DD/MM/YYYY')
              .subtract(1, 'week')
              .startOf('day')
              .tz(this.timeZone)
              .format()
          : moment()
              .startOf('day')
              .tz(this.timeZone)
              .format();
        const end_ = end
          ? moment(end, 'DD/MM/YYYY')
              .endOf('day')
              .tz(this.timeZone)
              .format()
          : start
          ? moment(start, 'DD/MM/YYYY')
              .add(1, 'week')
              .endOf('day')
              .tz(this.timeZone)
              .format()
          : moment()
              .add(1, 'week')
              .startOf('day')
              .tz(this.timeZone)
              .format();

        const goToDate = this.GoToDate
          ? moment(this.GoToDate, 'DD/MM/YYYY').toISOString()
          : null;
        fetchCalendarList(
          goToDate,
          this.clinicId,
          this.doctorId,
          end_,
          this.isHomeVisit,
          this.onlySessions,
          this.onlyTeleAssessment,
          start_,
        )
          .then(
            action(res => {
              this.sessions = res.itemList;
              this.setFieldsValue({ loading: false });
            }),
          )
          .catch(() => {
            notification.destroy();
            notification.error({
              message: 'Error occred while fetching calendar events.',
              description:
                'Please report this to system administrator and try again later.',
            });
          });
      } else {
        return this.toggleModal(true, {
          modalType: 'confirm',
          message: 'Both from and to appointment dates must be entered',
        })();
      }
    }
    if (this.calendarViewMode === 'dailyBookingByRooms') {
      if (!!this.clinicId && this.dateForDailyBooking) {
        this.setFieldsValue({ loading: true });
        const bookingsDate = moment(
          this.dateForDailyBooking,
          'DD/MM/YYYY',
        ).toISOString();
        getDailyBookingsByRoom(bookingsDate, this.clinicId).then(
          action(res => {
            this.dataDailyBooking = res;
            this.setFieldsValue({ loading: false });
          }),
        );
      }
    }
  };

  @action clearStore = () => {
    this.loading = true;

    this.dataDailyBooking = null;
    this.clinics = [];
    this.sessions = [];
    this.doctors = [];
    this.initialView = 'dayGridMonth';
    this.clients = [];
    this.keywordClient = '';
    this.numberClient = 30;
    this.isReloadCalendar = false;
    this.isResetStore = true;
    this.currentDate = null;

    this.timeZone = moment.tz.guess();
    //----------------------------------------------------------------
    this.GoToDate = '';
    this.dateForDailyBooking = '';
    this.clinicId = 0;
    this.doctorId = 0;
    this.end = `${moment()
      .add(6, 'month')
      .format('DD/MM/YYYY')}`;
    this.start = `${moment()
      .subtract(1, 'week')
      .format('DD/MM/YYYY')}`;
    this.isHomeVisit = false;
    this.onlySessions = false;
    this.onlyTeleAssessment = false;

    //----------------------------------------------------------------
    this.specialistKeyword = '';
    this.specialistNumber = 30;
    //----------------------------------------------------------------
    this.clinicId = 0;
    this.isHomeVisit = false;
    this.calendarViewMode = 'month';

    this.open = false;
    this.pageGetter = null;
    this.fieldName = null;
    this.modalParams = {};
  };

  @action fetchCalendarList = () => {
    if (this.calendarViewMode !== 'dailyBookingByRooms') {
      this.setFieldsValue({ loading: true });

      const start = this.start
        ? moment(this.start, 'DD/MM/YYYY').format('DD/MM/YYYY')
        : null;
      const end = this.end
        ? moment(this.end, 'DD/MM/YYYY').format('DD/MM/YYYY')
        : null;
      const start_ = start
        ? moment(start, 'DD/MM/YYYY')
            .startOf('day')
            .tz(this.timeZone)
            .format()
        : end
        ? moment(end, 'DD/MM/YYYY')
            .subtract(1, 'week')
            .startOf('day')
            .tz(this.timeZone)
            .format()
        : moment()
            .startOf('day')
            .tz(this.timeZone)
            .format();
      const end_ = end
        ? moment(end, 'DD/MM/YYYY')
            .endOf('day')
            .tz(this.timeZone)
            .format()
        : start
        ? moment(start, 'DD/MM/YYYY')
            .add(1, 'week')
            .endOf('day')
            .tz(this.timeZone)
            .format()
        : moment()
            .add(1, 'week')
            .startOf('day')
            .tz(this.timeZone)
            .format();

      const goToDate = this.GoToDate
        ? moment(this.GoToDate, 'DD/MM/YYYY').toISOString()
        : null;
      fetchCalendarList(
        goToDate,
        this.clinicId,
        this.doctorId,
        end_,
        this.isHomeVisit,
        this.onlySessions,
        this.onlyTeleAssessment,
        start_,
      )
        .then(
          action(res => {
            this.sessions = res.itemList;
            this.setFieldsValue({ loading: false });
          }),
        )
        .catch(() => {
          notification.destroy();
          notification.error({
            message: 'Error occred while fetching calendar events.',
            description:
              'Please report this to system administrator and try again later.',
          });
        });
    }
    autorun(() => {
      this.setFieldsValue({ loadingClients: true });
      getClientList(this.keywordClient, this.numberClient).then(
        action(res => {
          this.clients = res.itemList;
          this.setFieldsValue({ loadingClients: false });
        }),
      );
    });

    if (this.calendarViewMode === 'dailyBookingByRooms') {
      if (!!this.clinicId && this.dateForDailyBooking) {
        this.setFieldsValue({ loading: true });
        const bookingsDate = moment(
          this.dateForDailyBooking,
          'DD/MM/YYYY',
        ).toISOString();
        getDailyBookingsByRoom(bookingsDate, this.clinicId).then(
          action(res => {
            this.dataDailyBooking = res;
            this.setFieldsValue({ loading: false });
          }),
        );
      }
    }

    if (!api.isDoctor()) {
      autorun(() => {
        this.setFieldsValue({ loadingSpecialists: true });

        fetchSpecialists(this.specialistKeyword, this.specialistNumber).then(
          action(res => {
            this.doctors = res.itemList;
            this.setFieldsValue({ loadingSpecialists: false });
          }),
        );
      });
    }

    if (!api.isDoctor()) {
      autorun(() => {
        this.setFieldsValue({ loadingClinics: true });
        if (!!!this.doctorId) {
          fetchAllClinic().then(
            action(res => {
              this.clinics = res.itemList;
              this.setFieldsValue({ loadingClinics: false });
            }),
          );
        } else {
          fetchClinic(this.doctorId).then(
            action(res => {
              this.clinics = res.itemList;
              this.setFieldsValue({ loadingClinics: false });
            }),
          );
        }
      });
    } else {
      autorun(() => {
        this.setFieldsValue({ loadingClinics: true });
        fetchClinic(api.currentUser.data.DoctorId).then(
          action(res => {
            this.clinics = res.itemList;
            this.setFieldsValue({ loadingClinics: false });
          }),
        );
      });
    }
  };

  handleViewModeChange = mode => {
    return action(() => {
      this.calendarViewMode = mode;
    });
  };
}

export default new Store();
